import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import { API2_HOST, SUNFLOW_URL } from "helpers/urlHelper";

const Sunflow = () => {
    const navigate = useNavigate();

    useEffect(() => {
        let url = `${API2_HOST}/sunflow/login`;
        console.log("Hello!!");
        axios({
            method: 'get',
            url: url,
        }).then(res => {
            let otp = res.data.otp;
            console.log("Sunflow success", otp);
            window.open(`${SUNFLOW_URL}/Identity/Account/LoginWithOTP?otp=${otp}&redirect=/CSO/ServiceDesk/KanbanBoard`, "_blank");
        }).catch(err => {
            console.log("Sunflow error", err);
        });
        
        navigate(-1);

    });

    return (<></>);
}

export default Sunflow;